import { JournodexGeographyModel } from '../../../Common/Journodex/models/journodex-geography.model';
import { JournodexGeographicEntityModel } from '../../../Common/Journodex/models/journodex-geographic-entity.model';
import { LocalizedEnum } from '../../../api/journodex/model/localized-enum';
import { JournodexSubjectModel, JournodexSubjectParentModel } from '../../../Common/Journodex/models/journodex.subject.model';
import { ContactApiModel, EntityApiModel, PrivateContactMetadataApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { HandleModel } from './handle.model';
import { EntityType } from '../../../api/targeting/enum/entity.type.enum';
import { Badge } from './targeting-result.model';
import { LanguageModel } from '../../../Core/Localization/models/language.model';
import { SubjectUtils } from '../../../Common/Journodex/services/journodex-subjects.service';

// 30 days
export const FRESHNESS_THRESHOLD_MS = 30 * 24 * 60 * 60 * 1000;
// 90 days
export const VERIFIED_THRESHOLD_MS = 90 * 24 * 60 * 60 * 1000;

// 10 years
export const VETERAN_THRESHOLD_MS = 10 * 365 * 24 * 60 * 60 * 1000;
export class BaseJournodexEntityModel {

    id: string;
    entityType: EntityType;
    creationDate?: Date;
    primaryLanguage?: string;
    languages?: LanguageModel[] = [];
    bio?: string;
    addressLine1?: string;
    addressLine2?: string;
    postalCode?: string;
    researchNotes?: string;
    circulationTier?: number;
    avatarUrl?: string;
    isGeoRestricted?: boolean;

    badges: Badge[];

    targetAudienceRegions?: JournodexGeographyModel[]; // Maps to areasOfCoverage on backend
    geography?: JournodexGeographyModel;
    countryOfOrigin?: JournodexGeographicEntityModel;
    coverageFocus?: LocalizedEnum;
    handles?: HandleModel[] = [];
    subjects?: JournodexSubjectParentModel[] = [];

    // For convenience
    primaryEmail?: string;

    constructor(apiModel?: EntityApiModel, locale?: string) {
        if (apiModel) {
            this.id = apiModel.id;
            this.primaryLanguage = apiModel.primaryLanguage;
            this.bio = apiModel.bio;
            this.addressLine1 = apiModel.addressLine1;
            this.addressLine2 = apiModel.addressLine2;
            this.postalCode = apiModel.postalCode;
            this.researchNotes = apiModel.researchNotes;
            this.circulationTier = apiModel.circulationTier;
            this.avatarUrl = apiModel.avatarUrl;
            this.isGeoRestricted = apiModel.isGeoRestricted;

            if (apiModel.languages) {
                this.setLanguages(apiModel.languages);
            }

            if (apiModel.geography) {
                this.geography = new JournodexGeographyModel(apiModel.geography, locale);
            }
            if (apiModel.countryOfOrigin) {
                this.countryOfOrigin = new JournodexGeographicEntityModel(apiModel.countryOfOrigin.id, apiModel.countryOfOrigin.names);
            }
            if (apiModel.coverageFocus) {
                this.coverageFocus = new LocalizedEnum(apiModel.coverageFocus);
            }
            // if (apiModel.subjects) {
            //     this.subjects = SubjectUtils.createParentSubjectArrayFromApi(apiModel.subjects);
            //     this.subjects = SubjectUtils.filterPartiallySelectedParentSubjects(
            //         apiModel.subjects.map(subject => new JournodexSubjectModel(subject))
            //     );
            // }
            if (apiModel.areasOfCoverage) {
                this.targetAudienceRegions = apiModel.areasOfCoverage.map(aoc => new JournodexGeographyModel(aoc, locale));
            }
            if (apiModel.creationDate) {
                this.creationDate = new Date(apiModel.creationDate);
            }
        }
    }


    setLanguages(languages: string[]): void {
        this.languages = languages.map(language => {
            const id = language.slice(0, 2);

            return new LanguageModel(id);
        });
    }

    protected dateDeltaToNow(previousDate: string | Date): number {
        return new Date().getTime() - new Date(previousDate).getTime();
    }
}
